import { createContext, useContext, useMemo, useState } from 'react';
import { MessageType } from 'components/new/Page/PageMessages';

type PageMessagesContextValue = {
  addMessage: (message: MessageType) => void;
  removeMessage: (key: MessageType['key']) => void;
};

export const PageMessagesContext =
  createContext<PageMessagesContextValue | null>(null);

export const usePageMessages = () => {
  const context = useContext(PageMessagesContext);
  if (!context)
    throw new Error(
      'usePageMessages must be used within a PageMessagesContext.Provider',
    );
  return context;
};

export const usePageMessagesState = (
  initialMessages: Array<MessageType> = [],
) => {
  const [messages, setMessages] = useState<Array<MessageType>>(initialMessages);

  const addMessage = (message: MessageType) => {
    setMessages((prev) => [
      ...prev.filter((m) => m.key !== message.key),
      message,
    ]);
  };

  const removeMessage = (key: MessageType['key']) => {
    setMessages((prev) => prev.filter((m) => m.key !== key));
  };

  const contextValue = useMemo(() => ({ addMessage, removeMessage }), []);

  return { messages, contextValue };
};
